import React from "react";
import PageLayout from "../../layouts/PageLayout";

export default function BlankPage() {
    return (
        <PageLayout>
            <div className="mc-card p-sm-5">
        <h5>COMING SOON</h5>
      </div>
        </PageLayout>
    )
}